/**
 * Global configuration class for the Excel Add-in
 * Centralizes API endpoints, settings, and constants
 */
export class Config {
  // API Configuration

  // Set to true for production, false for staging
  private static isProd = true;

  private static readonly API_BASE_URL = (this.isProd ? 'https://reporting-automation-api-hme4hvd2fpc5cwhk.eastus2-01.azurewebsites.net/api/' : 'https://reporting-automation-api-staging-ftbahmcrgvaugve3.eastus2-01.azurewebsites.net/api/');
  
  // API Endpoints
  public static readonly API_ENDPOINTS = {
    GET_CLIENT_DATA: `${this.API_BASE_URL}GetClientData`,
    GET_CLIENT_LIST: `${this.API_BASE_URL}GetClientList`,
    GET_CLIENT_MONTHS: `${this.API_BASE_URL}GetClientDataMonths`,
    HANDLE_SUBMISSION: `${this.API_BASE_URL}HandleSubmission`,
    SUBMIT_CLIENT_MAPPING: `${this.API_BASE_URL}SubmitClientMapping`,
    GET_CLIENT_MAPPING: `${this.API_BASE_URL}GetClientMapping`,
    GET_USER_DATA: `getuserdata`, 
    GET_ERROR_DATA: `${this.API_BASE_URL}GetDocErrors`, 
  } as const;

  // Authentication Configuration
  public static readonly AUTH = {
    CLIENT_ID: 'a31aa7d3-d568-4c64-9b10-b100a69e64cb',
    REFRESH_BUFFER_SECONDS: 90, // 1.5 minutes
    DEFAULT_LIFETIME_SECONDS: 900, // 15 minutes
  } as const;

  // File Upload Configuration
  public static readonly UPLOAD = {
    ACCEPTED_EXTENSIONS: ['.xlsx', '.xls', '.csv', '.pdf'],
    DEFAULT_TIMEOUT_MS: 120000, // 2 minutes,
    
    // Helper methods for different formats
    getExtensionsForDisplay(): string {
      return this.ACCEPTED_EXTENSIONS.join(', ');
    },
    
    getExtensionsForAccept(): string {
      return this.ACCEPTED_EXTENSIONS.join(',');
    }
  } as const;

  // Excel Sheet Names
  public static readonly EXCEL_SHEETS = {
    MED_RX_CLAIM_DATA: 'Med Rx Claim Data',
    ENROLLMENT_DATA: 'Enrollment Data',
    MEMBERSHIP_DATA: 'Membership Data',
    LARGE_CLAIMS: 'Large Claims Data',
    LARGE_CLAIMS_REPORT: 'Large Claim Report',
  } as const;

  // Group Type Patterns for Enrollment Processing
  public static readonly GROUP_TYPE_PATTERNS = {
    ee: ['employee only', 'employee', 'single', 'subscriber', 'sub only', 'suboly'],
    es: ['employee + spouse', 'emp + spouse', 'spouse', 'subsps', 'sub and spouse', 'employee + 1'],
    ec: ['employee + child', 'employee + children', 'children', 'child', 'subchd', 'sub and children'],
    fam: ['family', 'employee + family', 'emp + family', 'sub and family', 'subfam'],
  } as const;

  // UI Configuration
  public static readonly UI = {
    DEBOUNCE_DELAY_MS: 200,
  } as const;

  // Prevent instantiation
  private constructor() {}
}
